import api from "./api";

export const getCurrentCompany = async () => {
  const response = await api.get("/api/v1/companies/current");
  return response.data;
};

export const updateCompanySettings = async (companyId, payload) => {
  const response = await api.put(
    `/api/v1/companies/${companyId}/settings`,
    payload,
  );
  return response.data;
};

export const uploadCompanyLogo = async (companyId, file) => {
  const formData = new FormData();
  formData.append("logo", file);

  const response = await api.post(
    `/api/v1/companies/${companyId}/logo`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};
